import { MainLayout } from "/src/ui-components/layouts/MainLayout";

const App = () => {
    return (
        <MainLayout />
    )
};

export default App;